import { defineStore } from "pinia";
export const useLK = defineStore({
  ...window.LKStore
});